import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { connect } from 'react-redux';
import { useLocale } from 'next-intl';

import LogoIcon from '../../icons/logo/logo';
import StyledModalFooter from './modalFooter.style';

const ModalFooter = ({ currentLevel, className }) => {
  const locale = useLocale();
  return (
    <StyledModalFooter className={className} currentLevel={currentLevel}>
      <Link
        href={{
          pathname: '/time',
          query: { slug: 'index', lang: locale, filters: null, page: 1 }
        }}
        as={`/${locale}`}
        className="modalFooter__logo"
        aria-label="Homepage "
      >
        <LogoIcon />
      </Link>
    </StyledModalFooter>
  );
};

ModalFooter.propTypes = {
  className: PropTypes.string,
  currentLevel: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  currentLevel: state.navigation.currentLevel
});

export default connect(mapStateToProps)(ModalFooter);
